//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'

const options = {
    scrollY: true, // 因为scrollY默认为true，其实可以省略
    scrollbar : true,
    click: true, //默认为false 不可点击
    pullDownRefresh : {
        threshold: 50, // 当下拉到超过顶部 50px 时，触发 pullingDown 事件
        stop: 20 // 刷新数据的过程中，回弹停留在距离顶部还有 20px 的位置
    },
    pullUpLoad : {
        threshold: -5 // 在上拉到超过底部 5px 时，触发 pullingUp 事件
    }
}
export default {
    name: "priceList",
    data () {
        return {
            height:window.innerHeight,
            roomList:[],
            page: 1,
            pageSize: 10,
            refreshListMsg : null,
            moreListMsg : null,
            shopId : this.$route.params.shopId

        };
    },
    mounted(){
        this.$nextTick(() => {
            this.scroll = new BScroll(this.$refs.priceList, options)
            // 监听下拉刷新
            this.scroll.on('pullingDown', () => {
                let toLoadPage = 1;
                console.log('pullingDown')
                // 刷新数据的过程中，回弹停留在距离顶部还有20px的位置
                this.fetchData(toLoadPage, (newData) => {
                    console.log(newData)
                    //this.data = newData
                    // 在刷新数据完成之后，调用 finishPullDown 方法，回弹到顶部
                    if (newData.data != undefined) {
                        if (newData.data.length > 0) {
                            // 重新刷新数据
                            this.roomList = newData.data
                            this.page = 2;
                            let _this = this;
                            setTimeout(function() {
                                _this.scroll.refresh();
                            }, 50);
                        } else {
                            // 返回数据为空
                            this.refreshListMsg = '返回数据异常，请稍后重试'
                        }
                    } else {
                        // 返回异常，刷新失败
                        this.refreshListMsg = '请求异常，请稍后重试'
                    }
                    this.scroll.finishPullDown()
                    // 只要刷新了数据，允许在拉历史数据
                    this.moreListMsg = null
                    this.scroll.finishPullUp()
                 })
                //this._RefreshData()
                //this.scroll.finishPullDown()
            })

            // 监听上拉加载新数据
            this.scroll.on('pullingUp', () => {
                this.fetchData(this.page, (newData) => {
                    // console.log("this.page = "+this.page);
                    if (newData.data != undefined) {
                        if (newData.data.length > 0) {
                            this.page++;
                            // 追加数据到当前元素
                            for (let i = 0; i < newData.data.length; i++) {
                                this.roomList.push(newData.data[i])
                            }
                            // 允许上拉
                            this.scroll.finishPullUp()
                        } else {
                            // 提醒没有更多数据了,锁定更多数据
                            this.moreListMsg = '没有更多数据了'
                        }
                    } else {
                        // 网络异常，请稍后再试
                        this.moreListMsg = '请求异常，请稍后重试'
                    }
                    //this.data = newData
                    // 在刷新数据完成之后，调用 finishPullDown 方法，回弹到顶部
                })
            })
        })
    },
    methods:{
        // 获取数据
        fetchData(toLoadPage, callback){
            let shopId = this.shopId
            let _this = this;
            let uri = '?page='+toLoadPage+'&pageSize='+_this.pageSize;
            console.log("fetchData, uri = "+uri);
            _this.axios.get('/v1/shop/'+shopId+'/prices'+uri, null, {
                headers: {}
            }).then(function (response) {
                // console.log(callback);
                callback&&callback(response.data);
            }).catch(function (response) {
                console.log(response);
                // 加载失败状态返回
            });
        },
        openPriceDetail(roomId) {
            this.$router.push({
                path: '/shop/'+ this.$route.params.shopId +'/tuanGoods/'+roomId+'/price'
            })
            // return {
            //     path: '/shop/'+ this.$route.params.shopId +'/room/'+roomId+'/price'
            // }
        }
    },
    created(){
        let _this = this;
        this.fetchData(_this.page, (newData) => {
            if(newData.data != undefined){
                _this.roomList = newData.data;
                if (newData.data.length > 0) {
                    _this.page ++;
                }
            }
        })
    }

}



// WEBPACK FOOTER //
// ./src/components/tuan_price/List.vue